import { removeProductSkuPrefix } from '~~/helpers/product/removeProductSkuPrefix';

const SPARE_PARTS_CATALOG_URL = 'https://manuals.expondo.com/spare-parts';

export function getSparePartsUrl(sku: string): string {

  const cleanSku = removeProductSkuPrefix(sku);

  return `${SPARE_PARTS_CATALOG_URL}/${encodeURIComponent(cleanSku)}`;

}
